import { type BrandedRouterPathsInterface } from './TypedRoute.tsx';

export interface ILocationState {
  from: { pathname?: keyof BrandedRouterPathsInterface | undefined };
  hasLoggedOut?: boolean;
}

/**
 * Gestiamo lo stato della location per il redirect dopo il login.
 * Se non c'è uno stato, il redirect sarà verso la pagina delle domande.
 * Se c'è uno stato, ma è `hasLoggedOut = true`, significa che c'è stato un logout da parte dell'utente.
 * In questo caso, il redirect sarà verso la pagina delle domande.
 * Altrimenti ritorniamo lo state, che dovrebbe contenere la pagina di provenienza.
 *
 * In questo modo:
 * - Si è sempre portati alla "home" se si è appena effettuato il logout o si è arrivati direttaemnte dalla pagina di login
 * - Si è portati all'ultima pagina visitata nella quale non si era autenticati, altrimenti.
 */
export function getLocationState(
  location: { state?: ILocationState },
  homePath: keyof BrandedRouterPathsInterface,
) {
  const { state } = location;
  if (!state) return { from: { pathname: homePath } };
  if (state.hasLoggedOut) return { from: { pathname: homePath } };
  return state;
}
